import cx from "clsx";
import Divider from "kreate-common/modules/kreate-ui/components/Divider";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import { MdInfoOutline } from "react-icons/md";

import RadioGroup from "../../../ModalUpdateListingDetailsConfirmation/components/RadioGroup";
import Alert from "../../components/Alert";

import { useFieldMintingMethod } from "./hooks";
import styles from "./index.module.scss";

import CollapsibleFieldSet from "@/modules/kreate-components/components/CollapsibleFieldSet";
type Props = {
  className?: string;
  style?: React.CSSProperties;
  api: ReturnType<typeof useFieldMintingMethod>;
};

export default function FieldMintingMethod({ className, style, api }: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <CollapsibleFieldSet showLabelAs="div" label="(Advanced) Minting Options">
        <RadioGroup.Root
          value={api.draft}
          onChange={api.setDraft}
          allowedValues={["on-demand-minting", "reservation-based-minting"]}
        >
          <Flex.Col gap="24px">
            <Flex.Col gap="16px">
              <RadioGroup.Item
                value="on-demand-minting"
                content="Mint-on-Demand"
              />
              <Alert
                icon={<MdInfoOutline />}
                content={
                  "Allow Collectors to mint in a single transaction. " +
                  "Suitable distribution for most Artworks."
                }
              />
            </Flex.Col>
            <Divider.Horizontal />
            <Flex.Col gap="16px">
              <RadioGroup.Item
                value="reservation-based-minting"
                content="Reservation-based Minting"
              />
              <Alert
                icon={<MdInfoOutline />}
                content={
                  "Require Collectors to make a reservation transaction in order to mint. " +
                  "This allows for orderly minting of extremely high-demand works."
                }
              />
            </Flex.Col>
          </Flex.Col>
        </RadioGroup.Root>
      </CollapsibleFieldSet>
    </div>
  );
}
